export const PREF_JA_GANHOU = "pref_ja_ganhou_presente";
export const PREF_QUAL_PRESENTE = "pref_qual_presente";
export const PREF_QUER_PRESENTE = "pref_quer_presente";

export const PRESENTE_GANHOU_PLACEHOLDER = "Ex: lenço, pulseira, cinto...";
export const PRESENTE_QUER_PLACEHOLDER = "Ex: carteira pequena, lenço, cinto fino...";

export const DEFAULT_PRESENTE_FIELDS = [
  {
    name: PREF_JA_GANHOU,
    label: "Já ganhou algum presente nosso?",
    type: "radio",
    options: ["Sim", "Não"],
    required: true,
  },
  {
    name: PREF_QUAL_PRESENTE,
    label: "O que você já ganhou?",
    type: "text",
    required: true,
  },
  {
    name: PREF_QUER_PRESENTE,
    label: "O que você quer ganhar de presente agora?",
    type: "text",
    required: true,
  },
];

export function isPresenteSurvey(survey) {
  if (!survey) return false;
  const title = String(survey.title || "").toLowerCase();
  if (title.includes("presente")) return true;
  const fields = survey.fields || [];
  return fields.some((f) => f.name === PREF_QUER_PRESENTE || f.name === PREF_JA_GANHOU);
}

export function normalizePresenteSurveyFields(fields) {
  const rows = (Array.isArray(fields) ? [...fields] : []).map((f) => ({ ...f }));
  return DEFAULT_PRESENTE_FIELDS.map((def) => {
    const found = rows.find((f) => f.name === def.name);
    return found ? { ...found, ...def } : { ...def };
  });
}

export function displayFieldLabel(field) {
  const def = DEFAULT_PRESENTE_FIELDS.find((f) => f.name === field?.name);
  return def?.label || field?.label || "";
}

export function showGanhouDetail(answers) {
  return answers?.[PREF_JA_GANHOU] === "Sim";
}

const JUNK_ANSWERS = new Set([
  ".", "..", "...", "—", "-", "x", "ok", "n/a", "na", "nenhum", "nao sei", "não sei",
]);

export function isMeaningfulText(value, minLen = 2) {
  const raw = String(value || "").trim();
  if (raw.length < minLen) return false;
  if (JUNK_ANSWERS.has(raw.toLowerCase())) return false;
  return /[a-zA-ZÀ-ÿ]{2,}/.test(raw);
}

export function isEmptyAnswer(field, value) {
  if (field?.type === "radio") return !value;
  if (field?.name === PREF_QUER_PRESENTE || field?.name === PREF_QUAL_PRESENTE) {
    return !isMeaningfulText(value, 2);
  }
  return !String(value || "").trim();
}

export function isSurveyComplete(fields, answers) {
  if (!Array.isArray(fields)) return false;
  return fields.every((field) => {
    if (field.name === PREF_QUAL_PRESENTE && !showGanhouDetail(answers)) return true;
    if (field.name === PREF_JA_GANHOU) return !isEmptyAnswer(field, answers[field.name]);
    if (field.name === PREF_QUER_PRESENTE || field.name === PREF_QUAL_PRESENTE) {
      if (field.name === PREF_QUAL_PRESENTE && !showGanhouDetail(answers)) return true;
      return !isEmptyAnswer(field, answers[field.name]);
    }
    if (!field.required) return true;
    return !isEmptyAnswer(field, answers[field.name]);
  });
}
